<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { getBankByBic } from '@/_company/helpers/contentful';

const bank = ref({});
const useSwishLogo = ref(false);

const store = useStore();
const user = computed(() => store.state.company.user.user);

const { swishNumber } = user.value.swishService;

onMounted(async () => {
  // Swish technical suppliers numbers starts with 987, should use Swish logo
  if (swishNumber.substring(0, 3) === '987') {
    useSwishLogo.value = true;
  } else {
    const bic = user.value.swishService.bic.substring(0, 6);
    bank.value = await getBankByBic(bic);
  }
});
</script>

<template>
  <div>
    <img
      v-if="useSwishLogo"
      class="swish-logo"
      src="@/assets/swish-logo-horizontal.svg"
      alt="Swish logotype"
    />

    <img
      v-else-if="bank && bank.logo"
      class="bank-logo"
      :src="bank.logo.fields.file.url"
      :alt="`${bank.name} logotype`"
    />
  </div>
</template>

<style lang="scss" scoped>
.swish-logo {
  width: 140px;
  height: auto;
}

.bank-logo {
  max-width: 100%;
  max-height: 56px;

  img {
    display: block;
  }
}
</style>
